export default "__VITE_ASSET__7taUAni___"